/*
 * @Date: 2020-08-24 09:39:35
 * @Author: MX
 * @Description:
 */
import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import routesMap from './router'
import NProgress from 'nprogress'

Vue.use(Router)

const Login = () => import(/* webpackChunkName: "layout" */ '@layout/Login.vue')
const Layout = () => import(/* webpackChunkName: "layout" */ '@layout/Layout.vue')
const Redirect = () => import(/* webpackChunkName: "layout" */ '../layout/Redirect.vue')
const comRouter = [
  { path: '/', redirect: '/singleOrder', component: Layout, children: [] },
  { path: '/singleOrder', name: 'singleOrder', meta: { title: '首页' }, component: Layout },
  { path: '/login', name: 'login', meta: { title: '登录' }, component: Login },
  { path: '/shopifylogin', name: 'shopifyLogin', meta: { title: '登录', pasToken: true }, component: () => import(/* webpackChunkName: "shopifylogin" */ '@views/shopify/Login.vue') },
  { path: '/shopifyauth', name: 'shopifyAuth', meta: { title: '订阅', pasToken: true }, component: () => import(/* webpackChunkName: "shopifyauth" */ '@views/shopify/Auth.vue') },
  { path: '/shopiftransfer', name: 'shopifyTransfer', meta: { title: '中转', pasToken: true }, component: () => import(/* webpackChunkName: "shopifyauth" */ '@views/shopify/Transfer.vue') },
  {
    path: '/redirect',
    name: 'redirect',
    component: Layout,
    children: [{ path: '/redirect/:path*', component: Redirect }] // 刷新空白页
  },
  { path: '*', redirect: '/singleOrder' }
]

comRouter[0].children = routesMap

const router = new Router({
  mode: 'history',
  routes: comRouter
})

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  // 设置密码页
  if (store.getters.token) {
    const { user } = store.state.base
    // 登录页
    if (to.name === 'login' && user) {
      next({ name: 'singleOrder' })
      NProgress.done()
    } else {
      if (!user) {
        next({
          redirect: true,
          name: 'login'
        })
      } else {
        next()
      }
    }
    if (to.name === 'setPassword') {
      next({
        redirect: true,
        name: 'login'
      })
    }
  } else { // token不存在
    if (to.name !== 'login' && to.name !== 'forgetPwd' && !to.meta.pasToken) {
      // 否则全部重定向到登录页
      next({
        redirect: true,
        name: 'login'
      })
    } else if (to.name === 'setPassword') {
      if (localStorage.getItem('oldPwd')) {
        next()
        return
      }
    } else if (from.name === 'shopifyAuth' && to.name !== 'shopifyLogin') {
      // shopify 订阅
      next({
        redirect: true,
        name: 'shopifyLogin'
      })
    } else {
      next()
    }
  }
  NProgress.done()
})
router.afterEach(() => {
  window.scrollTo(0, 0)
  NProgress.done()
})

export default router
